
    import {
        computed,
        defineComponent,
        ref,
        unref,
        type PropType,
    } from 'vue';
    import { uniq } from 'underscore';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import CheckBoxInputList from '@ve/components/inputs/CheckBoxInputList.vue';
    import { ExWindow } from '@fr/vue/types';
    import { IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';
    import { Typo } from '@travelata-libs/ui-kit';
    import getPrepaymentsList, { ProductWithPrepayments } from '../lib/getPrepaymentsList';

    declare let window: ExWindow;

    export default defineComponent({
        name: 'PrepaymentsFilter',
        components: {
            Typo,
            CheckBoxInput,
            CheckBoxInputList,
        },
        props: {
            tours: {
                type: Array as PropType<ProductWithPrepayments[]>,
                default: () => [],
            },
            filteredToursWithoutPrepayments: {
                type: Array as PropType<ProductWithPrepayments[]>,
                default: () => [],
            },
            selected: {
                type: Array as PropType<number[]>,
                default: () => [],
            },
        },
        emits: ['change'],
        setup(props, { emit }) {
            const isMobile = !!window?.appConfig?.isMobileDomain;
            const isHover = ref(-1);
            const isHoverAny = ref(false);

            const isAnySelected = computed(() => props.selected.length === 0);

            const firstPaymentsDifinitions = computed(() => {
                const firstPaymentDefinitions = (props.filteredToursWithoutPrepayments.reduce<number[]>((acc, t) => {
                    acc.push(...(t.firstPaymentDefinitions?.map((f) => f.firstPaymentPart * 100) || []));
                    return acc;
                }, []))
                return uniq(firstPaymentDefinitions);
            })

            const prepaymentsList = computed(() => {
                const list = getPrepaymentsList(props.tours);
                return list.map(({ name, value }) => {
                    return {
                        name,
                        value,
                        disabled: !props.selected.includes(value) && !firstPaymentsDifinitions.value.includes(value),
                    }
                });
            });

            const selectAny = () => {
                emit('change', []);
            };

            const onSelectionChange = (newSelected: number[]) => {
                emit('change', newSelected);
            };


            return {
                isAnySelected,
                selectAny,
                onSelectionChange,
                prepaymentsList,
                isMobile,
                isHover,
                isHoverAny,
            };
        },
    });
